import React, { useState, useEffect } from "react";
import { Form, Select, Input } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";

import { elvis } from "../../Utils";

const { Option } = Select;

/**
 * Not-structural building damage: element, damage type and a free-text
 * quantification (kept free until the scheme is agreed with the consortium).
 * The description lives in the generic damage panel.
 */
const NotStructuralDamageForm = props => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const isEditMode = props.isEditMode || false;
    const [elementTypes, setElementTypes] = useState([]);
    const [damageTypes, setDamageTypes] = useState([]);

    useEffect(() => {
        axios
            .get(process.env.REACT_APP_API_ENDPOINT + "/building/enums/non-structural-elements")
            .then(({ data }) => setElementTypes(data))
            .catch(error => console.log(error));
        axios
            .get(process.env.REACT_APP_API_ENDPOINT + "/building/enums/non-structural-damage-types")
            .then(({ data }) => setDamageTypes(data))
            .catch(error => console.log(error));
    }, []);

    useEffect(() => {
        if (props.record.damage) {
            form.setFieldsValue({
                nonStructuralElement: props.record.damage.nonStructuralElement,
                nonStructuralDamageType: props.record.damage.nonStructuralDamageType,
                damageQuantification: props.record.damage.damageQuantification,
            });
        }
    }, [props.record.damage, form]);

    const onFieldsChange = () => {
        if (!isEditMode) return;
        const values = form.getFieldsValue();
        const newDamage = { ...props.record };
        newDamage.damage.nonStructuralElement = elvis(values.nonStructuralElement);
        newDamage.damage.nonStructuralDamageType = elvis(values.nonStructuralDamageType);
        newDamage.damage.damageQuantification = elvis(values.damageQuantification);
        newDamage.damage.damageClass = props.damageClass;
        newDamage.valid = true;
        props.parentCallback(newDamage);
    };

    return (
        <Form
            form={form}
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            className="details_form"
            name="notStructuralDamageForm"
            onFieldsChange={onFieldsChange}
        >
            <Form.Item label="Non-structural element" name="nonStructuralElement">
                <Select allowClear disabled={!isEditMode}>
                    {elementTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('damageEnums.nonStructuralElement.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item label="Damage type" name="nonStructuralDamageType">
                <Select allowClear disabled={!isEditMode}>
                    {damageTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('damageEnums.nonStructuralDamageType.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item label="Damage quantification" name="damageQuantification">
                <Input placeholder="Free text for now" disabled={!isEditMode} />
            </Form.Item>
        </Form>
    );
};

export default NotStructuralDamageForm;
